var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-fullscreen-container",
    [
      _vm.$wf.isSmDown ? _c("app-toolbar") : _vm._e(),
      _c(
        "w-breadcrumb",
        [
          !_vm.$wf.isSmDown
            ? _c(
                "w-row",
                { attrs: { grow: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-wrap": "" } },
                        [
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              staticClass: "cancel mr",
                              on: {
                                click: function ($event) {
                                  return _vm.cancel()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.cancel")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "w-button",
                            {
                              attrs: {
                                icon: "pen",
                                disabled: !_vm.hasPermission,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.edit()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("common.edit")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("titles.view"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c("app-bank-info-default", {
                            attrs: { bank: _vm.bank },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }